import { HTMLProps, useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'
import { Text } from '@/shared/ui'

type CurrentTimeProps = HTMLProps<HTMLDivElement> & { locale: string }

const variantsTime = {
  visible: {
    opacity: 1,
    translateY: 0,
    transition: { duration: 0.4, delay: 0.36 },
  },
  hidden: { opacity: 0, translateY: 30 },
}

export const CurrentTime = ({ className, locale, ...restProps }: CurrentTimeProps) => {
  const translate = useTranslations()
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Moscow',
    })
  )

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString(locale, {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Moscow',
        })
      )
    }, 1000 * 60)

    return () => clearInterval(timerId)
  }, [])

  return (
    <Text className={className} variants={variantsTime} color="white" type="h2" tagName="span">
      {currentTime}
      <span className="text_color_red">&nbsp;{translate('timeZoneMSK')}</span>
    </Text>
  )
}
